// Store-wide Yotpo rating (header pill + footer reviews block).
// Liquid renders fallback numbers from block settings; this swaps in the live Yotpo totals:
// site reviews + product reviews (same v3 endpoints the /pages/resenas widget uses), with the
// average weighted by count. Cached per session so each page view doesn't refetch.
const nodes = document.querySelectorAll('[data-wrb-yotpo]');
const appKey = nodes[0]?.dataset.wrbYotpo;

if (appKey) {
  const cacheKey = `wrb-yotpo-bottomline-v3:${appKey}`;
  const base = `https://api-cdn.yotpo.com/v3/storefront/store/${appKey}`;

  const bottomline = async (path) => {
    const res = await fetch(`${base}/${path}?page=1&perPage=1`);
    if (!res.ok) throw new Error(res.status);
    return (await res.json()).bottomline;
  };

  const load = async () => {
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && Date.now() - cached.at < 3600000) return cached;
    } catch {}
    const [site, products] = await Promise.all([bottomline('product/yotpo_site_reviews/reviews'), bottomline('reviews')]);
    const count = site.totalReview + products.totalReview;
    const score = count ? (site.averageScore * site.totalReview + products.averageScore * products.totalReview) / count : 0;
    const data = { score, count, at: Date.now() };
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(data));
    } catch {}
    return data;
  };

  load()
    .then(({ score, count }) => {
      if (!count) return;
      const rounded = Math.round(score * 10) / 10;
      const full = Math.floor(rounded);
      const scoreText = rounded.toFixed(1);
      const countText = count.toLocaleString('es-MX');

      nodes.forEach((node) => {
        node.querySelectorAll('[data-wrb-yotpo-score]').forEach((el) => (el.textContent = scoreText));
        node.querySelectorAll('[data-wrb-yotpo-count]').forEach((el) => (el.textContent = countText));
        node.querySelectorAll('[data-wrb-yotpo-stars] svg').forEach((star, i) => {
          star.classList.toggle('is-on', i < full);
          star.classList.toggle('is-half', i === full && rounded > full);
        });
      });
    })
    .catch(() => {}); // Keep the Liquid fallback numbers.
}
